import MaterialUIListItemIcon from '@material-ui/core/ListItemIcon';
import { Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  root: {
    '& svg': {
      fontSize: theme.spacing(4),
      opacity: 0.75
    },
    color: '#343B46',
    marginRight: 0,
    minWidth: 0
  }
});

export const ListItemIcon = withStyles(styles)(MaterialUIListItemIcon);
